import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faPhone } from '@fortawesome/pro-solid-svg-icons';
import { } from "../component/options";

const print3461Form = [
    {
      name: 'form3461Date',
      label: 'Date',
      type: 'date',
      maxLength: undefined,
      placeholder: '',
      defaultValue: '',
      required: true,
      disabled: false,
      icon: undefined,
      sizeProp: { xs: 12, sm: 12, md: 12 }
    },
];

const optionsMap = {
	
};

export { print3461Form, optionsMap };